<script setup lang="ts">
// types
import type { FaqItem } from '@ts-sections/section-faq-multiple/interfaces'
// assets
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
// components
import { AppText } from '@UI/Typography/AppText'
import { AppTextMarkdown } from '@UI/Typography/AppTextMarkdown'
import { AppIcon } from '@UI/Icons/AppIcon'

defineOptions({
  name: 'BlockFaqItem',
})

defineProps<{
  item: FaqItem
  isOpen: boolean
}>()

defineEmits<{
  'click:toggle': []
}>()
</script>

<template>
  <div
    class="block-faq-item"
    :class="{ 'block-faq-item--open': isOpen }"
  >
    <button
      class="block-faq-item__header"
      type="button"
      :aria-expanded="isOpen"
      @click="$emit('click:toggle')"
    >
      <AppText
        tag="h3"
        name="body1-medium"
        color="slate-900"
        class="block-faq-item__title"
      >
        {{ item.title }}
      </AppText>
      <span class="block-faq-item__chevron">
        <AppIcon
          :icon="faChevronDown"
          size="medium"
          color="indigo-500"
        />
      </span>
    </button>

    <div class="block-faq-item__body-wrap">
      <div class="block-faq-item__body">
        <AppTextMarkdown
          v-if="item.description"
          :content="item.description"
          name="body2"
          color="slate-700"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/BlockFaqItem.scss" />
